<textarea
  [attr.id]="inputId()"
  [attr.placeholder]="placeholder()"
  [attr.autocomplete]="autocomplete()"
  [attr.rows]="rows()"
  [disabled]="disabled()"
  class="block w-full rounded-md px-3 py-1.5 text-base outline-1 -outline-offset-1 focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:focus:outline-primary-darkmode sm:text-sm/6"
  [ngClass]="
    disabled()
      ? 'bg-deactivated dark:bg-deactivated-darkmode text-on-deactivated dark:text-on-deactivated-darkmode outline-deactivated-outline dark:outline-deactivated-outline-darkmode'
      : 'bg-surface dark:bg-surface-darkmode text-on-surface dark:text-on-surface-darkmode outline-outline dark:outline-outline-darkmode'
  "
  [uiDebounce]="debounceMs()"
  (input)="displayValue.set($any($event).target.value)"
  (debouncedInput)="updateModel($event)"
  (blur)="touched.set(true)"
  >{{ displayValue() }}</textarea>
